export class Event {
  constructor() {
    this.id = undefined;
    this.eventId = { id: this.id };
    this.type = undefined;
    this.created = undefined;
    this.deleted = undefined;
    this.venueDetailsId = undefined;
    this.venueSetupId = undefined;
    this.venueSectionId = undefined;
    this.eventStart = undefined;
    this.eventEnd = undefined;
    this.eventName = undefined;
    this.description = undefined;
    this.imageLink = undefined;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    const event =  Object.assign(new Event(), json);
    return event;
  }
}
